import { useEffect, useRef, useState } from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import { AssetWrapper } from '../../assetComponents/assetWrapper/AssetWrapper';
import { BaseAssetProps } from '../../assetComponents/types';
import { ComponentType } from 'src/types/SCADA/componentsTypes';

type Props = BaseAssetProps;

export const TextLabel = ({ selected, width, height, data, id }: Props) => {
  const theme = useTheme();
  const textRef = useRef<HTMLDivElement | null>(null);
  const [measuredSize, setMeasuredSize] = useState<{ width: number; height: number }>({
    width: width ?? 50,
    height: height ?? 20,
  });

  const text = data?.text ?? 'Label';
  const background = data?.backgroundColor ?? theme.palette.grey[300];
  const color = data?.color ?? 'inherit';
  const fontSize = data?.textSize ?? '11px';

  useEffect(() => {
    const el = textRef.current;
    if (!el) return;
    const measure = () => {
      if (!textRef.current) return;
      const el = textRef.current;
      setMeasuredSize({
        width: el.scrollWidth,
        height: el.scrollHeight,
      });
    };
    measure();

    const observer = new ResizeObserver(() => measure());
    observer.observe(el);

    return () => observer.disconnect();
  }, []);

  return (
    <AssetWrapper
      id={id}
      selected={selected}
      width={measuredSize.width}
      height={measuredSize.height}
      type={ComponentType.TextLabel}
    >
      <Box
        ref={textRef}
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background,
          borderRadius: '6px',
          padding: '2px 8px',
        }}
      >
        <Typography sx={{ color, fontSize, fontWeight: '700', whiteSpace: 'nowrap' }}>
          {text}
        </Typography>
      </Box>
    </AssetWrapper>
  );
};
